import { AppMultiSelect, AppRemixIcon } from '@/layout/AppComponents';
import axios from 'axios';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { useParams } from 'react-router-dom';
import { axiosPath } from '../../../../routing/helpers/router';
import Translator from '../../helpers/Translator';
import useIsMounted from '../../hooks/useIsMounted';

export default function SelectLayout(props) {
  const {
    value,
    onHandleChange,
    className = 'mb-2',
    isMulti = true,
    allowSelectAll = true,
    hasSearchBox = false,
    hasSelectOptions = false,
  } = props;
  const { plantHex } = useParams();
  const isMounted = useIsMounted();
  const [layout, setLayout] = useState();
  const [layoutFilters, setLayoutFilters] = useState();
  const [layoutFiltersValue, setLayoutFiltersValue] = useState([]);
  const [layoutWithFilters, setLayoutWithFilters] = useState();

  // > LOAD LAYOUT //
  useEffect(() => {
    (async () => {
      try {
        const response = await axios.post(axiosPath('api_r_user_module_legalCompliance_evaluation_getLayout'), { plantHex });
        if (isMounted.current) {
          setLayout(response.data.layoutElements);
          if (response.data.layoutFilters) {
            setLayoutFilters(response.data.layoutFilters);
            setLayoutWithFilters(response.data.layoutElements);
          }
        }
      } catch (err) {}
    })();
  }, []);
  // < LOAD LAYOUT //
  const handleFilterChange = (opt) => {
    setLayoutFiltersValue(opt);
    const selectedFilters = layoutFilters.filter((f) => opt.includes(f.value));
    let availableLayouts = [];
    selectedFilters.forEach((sf) => {
      availableLayouts = [...availableLayouts, ...sf.layoutIDs];
    });
    setLayoutWithFilters(availableLayouts.length === 0 ? layout : _.filter(layout, (l) => availableLayouts.includes(l.value)));
    onHandleChange(_.map(_.filter(layout, (l) => availableLayouts.includes(l.value)), 'value'));
  };

  if (layoutFilters) {
    return (
      <>
        <AppMultiSelect
          options={layoutFilters}
          title={ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="type" />)}
          placeholder={ReactDOMServer.renderToString(<Translator file="user" name="select.one.or.multiple.elements" />)}
          value={layoutFiltersValue}
          onChange={(opt) => handleFilterChange(opt)}
          isMulti={isMulti}
          icon={<AppRemixIcon icon="apps-2" />}
          allowSelectAll
          hasSearchBox={hasSearchBox}
          hasSelectOptions={hasSelectOptions}
        />
        <AppMultiSelect
          options={layoutWithFilters}
          title={ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="layout" />)}
          placeholder={ReactDOMServer.renderToString(<Translator file="user" name="select.one.or.multiple.elements" />)}
          value={value}
          onChange={(opt) => onHandleChange(opt)}
          isMulti={isMulti}
          icon={<AppRemixIcon icon="apps-2" />}
          allowSelectAll
          hasSearchBox={hasSearchBox}
          hasSelectOptions={hasSelectOptions}
        />
      </>
    );
  }

  return (
    <AppMultiSelect
      options={layout}
      title={ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="layout" />)}
      placeholder={ReactDOMServer.renderToString(<Translator file="user" name="select.one.or.multiple.elements" />)}
      value={value}
      onChange={(opt) => onHandleChange(opt)}
      isMulti={isMulti}
      icon={<AppRemixIcon icon="apps-2" />}
      allowSelectAll
      isLoading={!layout}
      hasSearchBox={hasSearchBox}
      hasSelectOptions={hasSelectOptions}
    />
  );
}
